import lightGallery from "lightgallery";

// Plugins
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";

// Others
import Counters from "./components/counters";
import Sliders from "./components/sliders";
import Thumbnail from "lightgallery/plugins/thumbnail";

document.addEventListener("DOMContentLoaded", function () {
	Sliders();
	Counters();

	const burger = document.getElementsByClassName("header__right-burger")[0];
	const burgerWrapper = document.getElementsByClassName("burger-menu")[0];
	const burgerClose = document.getElementsByClassName("burger-menu__close")[0];

	if (burger) {
		burger.addEventListener("click", function () {
			burgerWrapper.classList.add("active");
		});
	}

	if (burgerClose) {
		burgerClose.addEventListener("click", function () {
			burgerWrapper.classList.remove("active");
		});
	}

	lightGallery(document.getElementById("lightgallery"), {
		plugins: [lgThumbnail, lgZoom],
		thumbnail: true,
		selector: ".gallery__item",
	});

	document.addEventListener("scroll", function () {
		if (window.scrollY > 0) {
			document.body.classList.add("scrolling");
		} else {
			document.body.classList.remove("scrolling");
		}
	});

	// Add "scrolling" class on page load if not at start position
	window.addEventListener("load", function () {
		if (window.scrollY > 0) {
			document.body.classList.add("scrolling");
		}
	});
});
